import { Box, Button, Typography } from '@mui/material'
import { useAppDispatch } from 'store'
import { actions as reportingBenchmarkActions } from 'store/reporting/benchmark'
import { BenchmarkFilters, BenchmarkReportRequest } from 'store/reporting/benchmark/types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import BenchmarkFiltersComponent from 'containers/benchmark/benchmarkReportGenerator/components/BenchmarkFiltersComponent'

type Props = {
  id: string
  name: string
  ipcrCodes: string[]
  origin: string
  companyNames?: string[]
  onCreated?: (id: string) => void
  isRegeneration?: boolean
}

export default function BenchmarkReportGenerator({
  id,
  name,
  ipcrCodes,
  origin,
  companyNames = [],
  onCreated,
  isRegeneration,
}: Props) {
  const dispatch = useAppDispatch()
  const defaultFilters: BenchmarkFilters = { startYear: 2000, grantedOnly: false, publicationDateOnly: false, companyNames }
  const [filters, setFilters] = useState<BenchmarkFilters>(defaultFilters)
  const error = useSelector((state: RootState) => state.reportingBenchmark.error.createBenchmark)
  const benchmarkId = useSelector((state: RootState) => state.reportingBenchmark.benchmarkId)

  useEffect(() => {
    if (benchmarkId && onCreated) {
      onCreated(benchmarkId)
    }
  }, [benchmarkId, onCreated])

  const handleSubmit = () => {
    const requestData: BenchmarkReportRequest = {
      id,
      name,
      ipcrCodes,
      ...filters,
      companyNames,
      origin,
      ...(isRegeneration ? { isRegeneration: true } : {}),
    }

    dispatch(reportingBenchmarkActions.createBenchmark(requestData))
  }

  return (
    <Box>
      <Typography>Create Benchmark Report with the following ipcr codes: {ipcrCodes.join(', ')}</Typography>
      <BenchmarkFiltersComponent filters={filters} setFilters={setFilters} companyNames={companyNames} />
      <Button variant="contained" color="primary" onClick={handleSubmit} sx={{ mt: 3 }}>
        {isRegeneration ? 'Regenerate Benchmark Report' : 'Create Benchmark Report'}
      </Button>
      {error && (
        <Typography variant="h6" color="error.main" fontSize={16}>
          {error}
        </Typography>
      )}
    </Box>
  )
}
